// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-642e185c] .config-input .v-input__slot {\n  min-height: 32px !important;\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n}\n.service-header[data-v-642e185c] {\n  line-height: 28px;\n}\n.no-service[data-v-642e185c] {\n  color: #A6A4A6;\n}", ""]);
// Exports
module.exports = exports;
